import { Component, OnInit, Input } from '@angular/core';
import { IBreadcrumbConfig } from '../../../core/interfaces/breadcrumb-config';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'aig-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class BreadcrumbComponent implements OnInit {

  @Input() config: IBreadcrumbConfig[] = [];

  constructor() {}

  ngOnInit(): void {
  
  }
}
